import { useState } from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";

import { Button, Box } from "@mui/material";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";

import "./style.scss";

export const DaysSelector = ({
  label = "",
  selectedDayAndTime,
  dateHasError,
  setSelectedDayAndTime,
}) => {
  const { t } = useTranslation();

  const [timePickerValue, setTimePickerValue] = useState(null);
  const [showTimePicker, setShowTimePicker] = useState(false);
  const [selectedDay, setSelectedDay] = useState(false);

  const daysOfWeek = [
    { id: "monday", label: "Mon" },
    { id: "tuesday", label: "Tue" },
    { id: "wednesday", label: "Wed" },
    { id: "thursday", label: "Thu" },
    { id: "friday", label: "Fri" },
    { id: "saturday", label: "Sat" },
    { id: "sunday", label: "Sun" },
  ];

  const handleSelectDay = (day) => {
    if (Object.keys(selectedDayAndTime).includes(day.id)) {
      setShowTimePicker(false);
      setSelectedDayAndTime((prevTimes) => {
        const updatedTimes = { ...prevTimes };
        delete updatedTimes[day.id];
        return updatedTimes;
      });
    } else {
      setSelectedDay(day.id);
      setShowTimePicker(true);
    }
  };

  const handleTimeChange = (newValue) => {
    setTimePickerValue(newValue);
  };

  const handleClose = () => {
    setShowTimePicker(false);
  };

  const handleAccept = () => {
    if (timePickerValue) {
      const formatedTime = format(timePickerValue, "HH:mm");
      setSelectedDayAndTime((prevTimes) => ({
        ...prevTimes,
        [selectedDay]: `${formatedTime}:00`,
      }));
    }
    setShowTimePicker(false);
  };

  return (
    <div className="days-selector-container">
      {label && <label>{label}</label>}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MobileTimePicker
          value={timePickerValue}
          onChange={handleTimeChange}
          onClose={handleClose}
          open={showTimePicker}
          ampm={false}
          slotProps={{
            textField: {
              style: {
                visibility: "hidden",
                width: "0px",
                height: "0px",
                zIndex: 1,
              },
            },
            dialog: {
              onClose: (event, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                  handleAccept();
                }
                setShowTimePicker(false);
              },
              disableEscapeKeyDown: true,
            },
            mobilePaper: {
              sx: {
                height: "410px",
              },
            },
          }}
          slots={{
            actionBar: () => (
              <Box sx={{ position: "absolute", bottom: 0, right: 0 }}>
                <Button onClick={handleClose} color="inherit">
                  Cancel
                </Button>

                <Button onClick={handleAccept} color="primary">
                  OK
                </Button>
              </Box>
            ),
          }}
        />
      </LocalizationProvider>
      <div className="days-container">
        {daysOfWeek.map((day) => (
          <div
            key={day.id}
            onClick={() => handleSelectDay(day)}
            className={
              Object.keys(selectedDayAndTime).includes(day.id) ? "selected" : ""
            }
          >
            {day.label}
            {selectedDayAndTime[day.id] && (
              <span>{selectedDayAndTime[day.id].slice(0, 5)}</span>
            )}
          </div>
        ))}
      </div>

      {dateHasError && (
        <p className="dateSelectionError">
          {t("error_days_and_time_required")}
        </p>
      )}
    </div>
  );
};
